import { h, ComponentChildren } from 'preact'

const BetaHeader = ({ children }: { children: ComponentChildren}) => {
  return (
    <div class='control-header--beta'>
      {children}
    </div>
  )
}

export default BetaHeader
